<template>
  <div id="app">
    <div class="preload portada-1" />
    <div class="preload portada-2" />
    <div class="preload portada-3" />

    <!-- Pantalla de selección de idioma -->
    <Preguntar v-if="idiomaSeleccionado === null" @idioma-seleccionado="establecerIdioma" />

    <!-- Español -->
    <template v-if="idiomaSeleccionado === 'es'">
      <InicioLogo
        v-if="isSmallScreen && !mostrarContenido"
        @logo-terminado="mostrarContenido = true"
      />
      <Componentep
        v-if="isSmallScreen && mostrarContenido"
        :id-invitado="idInvitado"
      />
      <pantalla-g v-else />
    </template>

    <!-- Inglés -->
    <template v-else-if="idiomaSeleccionado === 'en'">
      <InicioLogoIngles
        v-if="isSmallScreen && !mostrarContenido"
        @logo-terminado="mostrarContenido = true"
      />
      <ComponentePingles
        v-if="isSmallScreen && mostrarContenido"
        :id-invitado="idInvitado"
      />
      <pantalla-g v-else />
    </template>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import Preguntar from './components/preguntar.vue';
import InicioLogo from './components/inicio.vue';
import Componentep from './components/contenedor.vue';
import InicioLogoIngles from './components/ingles/inicio_ingles.vue';
import ComponentePingles from './components/ingles/contenedor_ingles.vue';
import PantallaG from './components/pantallas_g.vue';

export default {
  name: 'App',
  components: {
    Preguntar,
    InicioLogo,
    Componentep,
    InicioLogoIngles,
    ComponentePingles,
    PantallaG,
  },
  setup() {
    const route = useRoute();
    const idInvitado = ref(Number(route.params.idInvitado) || undefined);
    const idFestejado = ref(Number(route.params.idFestejado) || undefined);
    const isSmallScreen = ref(window.innerWidth < 768);
    const idiomaSeleccionado = ref(null);
    const mostrarContenido = ref(false); // ← NUEVO

    const isValidIdInvitado = computed(() => !isNaN(idInvitado.value) && idInvitado.value !== undefined);
    const isValidFestejado = computed(() => !isNaN(idFestejado.value) && idFestejado.value !== undefined);

const establecerIdioma = (idioma) => {
  idiomaSeleccionado.value = idioma;

  // Si quieres saltarte el logo y mostrar directamente contenedor.vue:
  if (isSmallScreen.value) {
    mostrarContenido.value = true;
  }
};

    watch(() => route.params.idInvitado, (newId) => {
      idInvitado.value = Number(newId);
    });

    watch(() => route.params.idFestejado, (newId) => {
      idFestejado.value = Number(newId);
    });

    window.addEventListener('resize', () => {
      isSmallScreen.value = window.innerWidth < 768;
    });

    return {
      idInvitado,
      idFestejado,
      isSmallScreen,
      idiomaSeleccionado,
      establecerIdioma,
      isValidIdInvitado,
      isValidFestejado,
      mostrarContenido, // ← NUEVO
    };
  }
};
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.preload {
  visibility: hidden;
  background-size: cover;
}

.preload.portada-1 {
}





</style>
